/* tslint:disable */
/* eslint-disable */
/**
 * Farseer API
 * Farseer API
 *
 * The version of the OpenAPI document: 3
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { MonthYearFromJSON, MonthYearToJSON } from './';
export function TimeRangeFromJSON(json) {
    return TimeRangeFromJSONTyped(json, false);
}
export function TimeRangeFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        from: MonthYearFromJSON(json['from']),
        to: MonthYearFromJSON(json['to']),
    };
}
export function TimeRangeToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        from: MonthYearToJSON(value.from),
        to: MonthYearToJSON(value.to),
    };
}
